import AppLayout from "@amzn/awsui-components-react/polaris/app-layout";
import SideNavigation, { SideNavigationProps } from "@amzn/awsui-components-react/polaris/side-navigation";
import { useRoutes } from "AppRoutes";
import { useLocation, useNavigate } from "react-router";
import { ReactProps } from "Types";
import getCommemorativeEmoji from "../utils/CommemorativeEmoji";
import "./IBAConsoleLayout.css";

const IBAConsoleSideNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const routes = useRoutes();
  const currentPage = location.pathname;
  const emoji = getCommemorativeEmoji();

  const handleOnSidebarNavigate = (event: CustomEvent<SideNavigationProps.FollowDetail>) => {
    event.preventDefault();
    const targetPage = event.detail.href;
    if (targetPage !== currentPage) {
      navigate(targetPage);
    }
  };

  return (
    <SideNavigation
      activeHref={currentPage}
      header={{ text: emoji + "IBA Console", href: `/` }}
      onFollow={handleOnSidebarNavigate}
      items={routes.map((route) => ({ type: "link", text: route.name, href: `/${route.page}` }))}
    />
  );
};

const IBAConsoleLayout = ({ children }: ReactProps) => (
  <AppLayout content={children} toolsHide navigation={<IBAConsoleSideNavigation />} />
);

export default IBAConsoleLayout;
